// src/context/AuthContext.jsx
import { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    const role = localStorage.getItem("userRole");

    if (isLoggedIn && role) {
      setUser({ role });
      // If trying to access /login while logged in → redirect away
      if (location.pathname === '/login') {
        navigate('/teacher/dashboard', { replace: true });
      }
    } else {
      setUser(null);
      if (location.pathname.startsWith('/teacher')) {
        navigate('/login', { replace: true });
      }
    }
    setLoading(false);
  }, [location.pathname, navigate]);

  const login = (role, data) => {
    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("userRole", role);
    // ... other items
    setUser({ role, ...data });
    navigate('/teacher/dashboard', { replace: true });
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
    navigate('/login', { replace: true });
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);